import {inject, injectable} from 'inversify'
import {SingletonService} from '@/common/dependency.configs'
import HttpHandler from '@/common/services/connect/HttpHandler'
import {useActiveCoreStore} from '@/common/stores/ActiveCoreStore'
import type RestResponse from '@/common/data/RestResponse.ts'

export interface ActiveCore {
  core: string
  url: string
}

@SingletonService
@injectable()
export default class ActiveCoreService {
  constructor(@inject(HttpHandler) private httpHandler: HttpHandler) {}

  getActiveCore(): Promise<ActiveCore> {
    const store = useActiveCoreStore()

    if (store.activeCore) {
      return Promise.resolve(store.activeCore)
    } else {
      return this.fetchActiveCore().then((response) => {
        store.setActiveCore(response.data.payload)
        return response.data.payload
      })
    }
  }

  fetchActiveCore(): Promise<RestResponse<ActiveCore>> {
    return this.httpHandler.get('{{launchpad}}/active-core')
  }
}
